import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectEvaluationsListItems } from "../../../../../../redux/evaluations/selector";
import { evaluations } from "../../../../../../redux/evaluations/action";

const ManagementEvaluations = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageSize, setPageSize] = useState(10);
	const [pageData, setPageData] = useState(1)
  const itemsData = useSelector(selectEvaluationsListItems)
  const [ columnDefs,setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
      setColumnDefs([
        {
          field: 'Sl',
          sortable: false,
          filter: false,
          isSortLabel: true,
          headerName: 'Sl',
          cellRenderer (params: any) {
            return parseInt(
              params.node.id,
              10
            ) + 1;
          },
        },
        { field: 'Name', headerName: 'Name' },
        { field: 'OwnerTypeName', headerName: 'OwnerType Name' },
        { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true }
      ]);
    }
  
  const handleDelete=(data: any)=>{
    dispatch(evaluations.delete({
      url: `https://evp.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/service/esa/evaluations/delete`,
      entity: 'evaluations',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
  })).then(() => {
    dispatch(evaluations.list({
      url: `https://evp.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/service/esa/evaluations/list`,
      entity: 'evaluations',
      jsonData: { "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc",}
    }));
  });
  }
      


  const fetchEvaluations=()=>{

    dispatch(evaluations.list({
      url:`https://evp.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/service/esa/evaluations/list`,
      entity:'evaluations',
      jsonData:{
      "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc"
    }}))     
  }
	useEffect(() => {
   
    createColumnDefs()
    fetchEvaluations()
	}, [pageData, pageSize])
    

	return (
    <>
    {itemsData?.isLoading ? 
    <PageLoader /> : 
    <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
    paginationData={itemsData?.result?.pagination} onDelete={handleDelete} headingName="Evaluations" />
    }
    </>
	);
};

export default ManagementEvaluations;


